import {
  likeCollectionById,
  removeLikeCollectionById,
} from "../api/like-collection/like-collection";

export function initCollectionLikeButtons(
  buttonClass = "js-collection-like-button",
  collectionIdAttr = "data-collection-id"
) {
  document.querySelectorAll(`.${buttonClass}`).forEach((button) => {
    const collectionId = button.getAttribute(collectionIdAttr);
    if (!collectionId) return;

    button.addEventListener("click", async () => {
      const isLiked = button.classList.contains("liked");

      setLoading(button, true);

      try {
        let apiLikeFunc = isLiked
          ? removeLikeCollectionById
          : likeCollectionById;
        const response = await apiLikeFunc(collectionId);
        const newLikesCount = response.likesCount || 0;

        updateButtonState(button, !isLiked, newLikesCount);
      } catch (error) {
        console.error("Like action failed:", error);
      } finally {
        setLoading(button, false);
      }
    });
  });
}

function updateButtonState(button, isLiked, likesCount) {
  const countSpan = button.querySelector(".like-count");
  button.classList.toggle("liked", isLiked);
  countSpan.textContent = likesCount;
}

function setLoading(button, isLoading) {
  button.disabled = isLoading;
  button.classList.toggle("loading", isLoading);
}
